import { useNavigation } from "react-router-dom"

const RouteLoading = () => {
  const navigation = useNavigation()

  if (navigation.state === "idle") return null

  return (
    <div className="fixed inset-x-0 top-0 z-100 h-0.5 overflow-hidden bg-blue-100">
      <div className="h-full w-1/3 animate-[route-loading_1.2s_ease-in-out_infinite] rounded-full bg-toicos-navy" />
    </div>
  )
}

export default RouteLoading
